import React from 'react';
import { Reveal } from './ui/Reveal';
import { GUIDE_IMAGE } from '../data/site';
const exercises = ['Respiración', 'Presencia', 'Autoobservación', 'Intención', 'Reconexión'];
export function BonusSection() {
  return <section className="bg-cream px-6 py-20 sm:py-28" data-id="element-17" data-mp="22f3f5ida9lp5">
      <div className="mx-auto grid max-w-5xl items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-18" data-mp="1yeb72sg5dmug">
        <Reveal data-id="element-19" data-mp="1ao7d7csrh1gn">
          <div className="relative" data-id="element-20" data-mp="1annv9w342d2m">
            <div className="absolute -inset-2.5 rounded-[1.75rem] border border-gold/35" data-id="element-21" data-mp="1aop6q1o1h1kv" />
            <img src={GUIDE_IMAGE} alt="Guía de Reconexión Energética" className="relative w-full rounded-[1.5rem] object-cover shadow-lift" data-id="element-22" data-mp="15qxf78rb3hh7" />
          </div>
        </Reveal>

        <Reveal delay={0.1} data-id="element-23" data-mp="1eo7r8wby7an6">
          <p className="text-[10px] font-semibold uppercase tracking-[0.26em] text-gold-dark sm:text-[11px]" data-id="element-24" data-mp="qzy8k3a17309">
            Y quiero regalarte algo para comenzar…
          </p>

          <h2 className="mt-5 font-serif text-[1.75rem] font-light leading-tight text-ink sm:text-4xl" data-id="element-25" data-mp="29s323dgjznan">
            Guía de Reconexión Energética
          </h2>

          <div className="mt-6 space-y-5 text-[17px] leading-relaxed text-ink-soft sm:text-[18.5px]" data-id="element-26" data-mp="2eplexexoymnx">
            <p data-id="element-27" data-mp="2jieezpi7t6to">
              No quiero que esperes hasta nuestra sesión para comenzar a
              escucharte.
            </p>
            <p data-id="element-28" data-mp="1qt8m615csgsw">
              Por eso recibirás una guía práctica con ejercicios que puedes
              utilizar para crear un espacio de pausa, presencia y
              autoobservación.
            </p>
          </div>

          <p className="mt-8 text-[10px] font-semibold uppercase tracking-[0.22em] text-ink-muted" data-id="element-29" data-mp="20qvhfy6ymkz1">
            Incluye ejercicios de
          </p>
          <ul className="mt-4 flex flex-wrap gap-2.5" data-id="element-30" data-mp="25rsw40srgwvs">
            {exercises.map(item => <li key={item} className="rounded-full border border-gold/40 bg-ivory px-4 py-2 text-[11px] font-medium uppercase tracking-[0.12em] text-ink-soft" data-id="element-31" data-mp="3c6ac2vbp50qz">
                {item}
              </li>)}
          </ul>

          <figure className="mt-9 border-l-2 border-gold/50 pl-6" data-id="element-32" data-mp="1c3ivpi8dx3me">
            <blockquote className="font-serif text-lg font-light italic leading-snug text-ink sm:text-xl" data-id="element-33" data-mp="1q4lkw3uoeu1j">
              Tu transformación no comienza cuando tienes todas las respuestas.
              Comienza cuando decides escucharte.
            </blockquote>
          </figure>
        </Reveal>
      </div>
    </section>;
}